import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "../../utils";
import DetailsHandlerDef from "../../details/DetailsHandlerDef";
import icons from "../../resources/icons";
export default Class(DetailsHandlerDef, {
  initialize: function initialize(options) {
    var isMore = true;
    if (typeof options !== 'undefined') if (typeof options.more !== 'undefined') isMore = options.more;
    var myOptions = {
      buttonText: "detaljer",
      buttonImage: icons.details.moreHeader,
      handler: this.myHandler,
      isApplicable: this.isApplicable,
      more: isMore
    };
    DetailsHandlerDef.prototype.initialize.apply(this, [myOptions]);
  },
  isApplicable: function isApplicable(result) {
    if (result.searcher && result.searcher.CLASS_NAME == 'Septima.Search.S4IndexSearcher') {
      var feature = result.data;

      if (typeof feature.hasDetails === "undefined") {
        feature.hasDetails = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = feature.pcol.row[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var row = _step.value;

            if (typeof row._name !== "undefined" && (row._name !== 'column' || row._name === 'column' && row.format === '' || row.format === 'hyperlink')) {
              feature.hasDetails = true;
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        return feature.hasDetails;
      }
    } else {
      return false;
    }
  },
  myHandler: function () {
    var _myHandler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var feature, items, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, row, icon, linkTitle, link, label, value, _label, _value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              feature = result.data;
              items = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 5;

              for (_iterator2 = feature.pcol.row[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                row = _step2.value;
                if (typeof row._name !== "undefined" && (row._name !== 'column' || row._name === 'column' && row.format === '' || row.format === 'hyperlink' || row.format === 'imageURL')) if (row.format === 'hyperlink') {
                  icon = icons.linksymbol;
                  linkTitle = row.label;
                  link = row.value;
                  items.push({
                    type: "link",
                    linkTitle: linkTitle,
                    link: link,
                    icon: icon
                  });
                } else if (row.format === 'imageURL') {
                  label = row.label;
                  value = row.value;
                  items.push({
                    type: "image",
                    label: label,
                    value: value
                  });
                } else {
                  _label = row.label;
                  _value = row.value;
                  items.push({
                    type: "labelvalue",
                    label: _label,
                    value: _value
                  });
                }
              }

              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](5);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 13:
              _context.prev = 13;
              _context.prev = 14;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 16:
              _context.prev = 16;

              if (!_didIteratorError2) {
                _context.next = 19;
                break;
              }

              throw _iteratorError2;

            case 19:
              return _context.finish(16);

            case 20:
              return _context.finish(13);

            case 21:
              return _context.abrupt("return", items);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 9, 13, 21], [14,, 16, 20]]);
    }));

    function myHandler(_x) {
      return _myHandler.apply(this, arguments);
    }

    return myHandler;
  }(),
  CLASS_NAME: 'Septima.Search.S4InfoHandler'
});